var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransform = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.6748 6.83105L12.8584 4.41602L13.5332 5.58398L9.34863 7.99902L13.5332 10.416L12.8584 11.584L8.6748 9.16797V14H7.3252V9.16797L3.1416 11.584L2.4668 10.416L6.65137 7.99902L2.4668 5.58398L3.1416 4.41602L7.3252 6.83105V2H8.6748V6.83105Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransform);
export default ForwardRef;